<script>

export default {
  name: 'delay-search',
  data () {
    return {
      countPerPage: 20,
      searchTimer: null,
      searchedObjs: [],
      keyword: ''
    }
  },
  methods: {
    delaySearch () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = window.setTimeout(() => {
        this.searchTimer = null
        this.search()
      }, 500)
    },
    search () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, this.countPerPage)
      this.currentPage = 1
      this.alertSearchResult()
    },
    searchWithoutAlertResult () {
      if (this.searchTimer !== null) window.clearTimeout(this.searchTimer)
      this.searchTimer = null
      this.filterObjs()
      this.tableData = this.searchedObjs.slice(0, this.countPerPage)
      this.currentPage = 1
    },
    alertSearchResult () {
      if (this.searchedObjs.length > 0) {
        this.$message({
          message: `搜尋結果共${this.searchedObjs.length}筆符合條件`,
          duration: 1000
        })
      } else {
        this.$message({
          message: '查無符合條件資料',
          duration: 1000
        })
      }
    }
  },
  created () {
  }
}
</script>
